import React from 'react';

export interface SVGNormalCheckProps {
  width?: string;
  height?: string;
  stroke?: string;
  strokeWidth?: string;
}

export const SVGNormalCheck = ({
  width = '17',
  height = '12',
  stroke = 'white',
  strokeWidth = '2',
}: SVGNormalCheckProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 5.5L6 10.5L15.5 1"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
